import { useState } from "react";
import { getWord } from "../../utils/functions";
import { useSelector } from "react-redux";
import axios from "axios";
import { BASE_URL } from "../../config";
import { LoadingButton } from "../Common/Loading";

const ChangePassword = () => {
  const user = useSelector((state) => state.user);
  const [data, setData] = useState({
    userId: user.userdata.id,
    password: "",
    confirmPassword: "",
    errors: {},
    loading: false,
  });

  const { userId, password, confirmPassword, errors, loading } = data;

  const handleChange = (e) => {
    setData((data) => ({
      ...data,
      [e.target.name]: e.target.value.trim(),
      errors: { ...data.errors, [e.target.name]: "" },
    }));
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    setData((data) => ({
      ...data,
      errors: {},
      loading: true,
    }));
    try {
      const passwordCheck =
        password === "" ? getWord("Please enter New Password") : "";
      const confirmPasswordCheck =
        confirmPassword === ""
          ? getWord("Please enter Confirm Password")
          : password !== confirmPassword
          ? getWord("Password and Confirm Password do not match")
          : "";
      if (passwordCheck !== "" || confirmPasswordCheck !== "") {
        setData((data) => ({
          ...data,
          errors: {
            ...data.errors,
            password: passwordCheck,
            confirmPassword: confirmPasswordCheck,
          },
          loading: false,
        }));
        return;
      }
      const postData = {
        userId,
        password,
      };
      const response = await axios.post(
        `${BASE_URL}/user/change-password`,
        postData
      );
      const result = response.data;
      if (result.message === "Success") {
        setData((data) => ({
          ...data,
          password: "",
          confirmPassword: "",
          errors: { ...data.errors, error: getWord("Updated Successfully") },
        }));
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.messages) {
        const messages = err.response.data.messages;
        Object.entries(messages).map(([field, message]) =>
          setData((data) => ({
            ...data,
            errors: { ...data.errors, [field]: message },
          }))
        );
      } else {
        setData((data) => ({
          ...data,
          errors: { ...data.errors, error: "An unexpected error occurred" },
        }));
      }
    } finally {
      setData((data) => ({ ...data, loading: false }));
    }
  };
  return (
    <>
      <div className="col-md-9">
        <div className="grid-layout wrapper-shop">
          <div className="tf-login-content">
            <div className="tf-page-cart-item">
              <form
                className="form-checkout"
                onSubmit={handleUpdate}
                autoComplete="off"
              >
                <div className="box grid-2">
                  <fieldset className="fieldset">
                    <label htmlFor="password">{getWord("New Password")}</label>
                    <input
                      autoComplete="off"
                      type="password"
                      name="password"
                      value={password}
                      onChange={handleChange}
                    />
                    {errors.password && (
                      <div className="error">{errors.password}</div>
                    )}
                  </fieldset>
                </div>
                <div className="box grid-2">
                  <fieldset className="fieldset">
                    <label htmlFor="confirmPassword">
                      {getWord("Confirm Password")}
                    </label>
                    <input
                      autoComplete="off"
                      type="password"
                      name="confirmPassword"
                      value={confirmPassword}
                      onChange={handleChange}
                    />
                    {errors.confirmPassword && (
                      <div className="error">{errors.confirmPassword}</div>
                    )}
                  </fieldset>
                </div>
                <div className="box fieldset">
                  <button className="tf-btn radius-3 btn-fill btn-icon animate-hover-btn justify-content-center">
                    {loading ? <LoadingButton></LoadingButton> : ""}
                    {getWord("Update")}
                  </button>
                  {errors.error && <div className="error">{errors.error}</div>}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
